<script lang="ts">
  import Grid from "$lib/components/Grid/Grid.svelte";
  import Column from "$lib/components/Column/Column.svelte";
  import { _ } from "svelte-i18n";
  import Button from "$lib/components/Button/Button.svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import { goto } from "$app/navigation";
  import Container from "$lib/components/Container/Container.svelte";
  import TopSpacer from "$lib/components/TopSpacer/TopSpacer.svelte";
  import type { Readable } from "svelte/store";
  import type { Page } from "@sveltejs/kit";
  import { page as pageStore } from "$app/stores";
  import { errorStore } from "$lib/stores/error";
  import { CustomerErrorCode } from "$lib/gql/gen/codegen";
  import { linkTo } from "$lib/utils/url";

  export let code: number;
  export let slot = false;

  let page: Readable<Page> = pageStore;

  $: if (
    code === 404 &&
    page &&
    $page?.url &&
    $page?.url?.searchParams &&
    $page.url.searchParams.get("brsr") &&
    typeof window !== "undefined"
  ) {
    goto(linkTo("/"));
  }

  let errorTitle = "";
  let errorMessage = "";

  switch ($errorStore.message) {
    case $_(CustomerErrorCode.UnidentifiedCustomer):
      errorTitle = $_("Error");
      errorMessage = $_("error.500.unidentified.customer");
      break;
    default:
      errorTitle = $_("Error");
      errorMessage = $_("Internal server error");
  }
</script>

<style lang="scss">
  .error {
    min-height: 100vh;
    padding: 48px 0;

    @include breakpoint(md) {
      padding: 64px 0;
    }

    @include breakpoint(lg) {
      padding: 80px 0 96px;
    }

    &--button {
      &__wrapper {
        margin-top: 64px;
        display: flex;
        justify-content: center;

        @include breakpoint(md) {
          display: block;
        }
      }
      max-width: 300px;
      width: 100%;
    }
  }
</style>

<Container>
  <TopSpacer />
  <div class="error">
    <Grid smCols={4} mdCols={8} lgCols={12}>
      <Column smSpan={4} mdSpan={8} lgSpan={12}>
        {#if code === 404}
          <Typography variant="h1" component="h1">{code}</Typography>
          <Typography variant="h1" component="h2"
            >{$_("Page not found")}</Typography
          >
          <div class="error--button__wrapper">
            <div class="error--button">
              <Button
                label={$_("Return to home?")}
                href={"/"}
                fullWidth={true}
                backgroundColor="var(--inverse-surface)"
                hoverTheme="inverse-on-surface"
                theme="inverse-on-surface"
              />
            </div>
          </div>
        {:else if $errorStore && $errorStore.message}
          <Typography variant="h1" component="h1">{errorTitle}</Typography>
          <Typography variant="body1" component="p">
            {errorMessage}
          </Typography>

          <div class="error--button__wrapper">
            <div class="error--button">
              <Button
                label={$_("contact.title")}
                href="./customer-service/contact-us"
                fullWidth={true}
                backgroundColor="var(--inverse-surface)"
                hoverTheme="inverse-on-surface"
                theme="inverse-on-surface"
              />
            </div>
          </div>
        {:else if code === 500}
          <Typography variant="h1" component="h1">{code}</Typography>
          <Typography variant="h1" component="h2">
            {$_("Internal server error")}
          </Typography>
          {#if slot}
            <slot />
          {/if}
        {/if}
      </Column>
    </Grid>
  </div>
</Container>
